var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_2123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.45663 5.12861C-0.485543 7.0937 -0.485543 10.2749 1.45663 12.24L6.33028 17.1712C8.27889 19.1428 11.4431 19.1428 13.3917 17.1712L16.906 13.6155L8.5181 5.12861C6.56949 3.157 3.40524 3.157 1.45663 5.12861ZM7.09562 6.5345L14.0935 13.6154L11.9693 15.7653C10.8036 16.9448 8.91847 16.9448 7.75276 15.7653L2.87911 10.8341C1.70696 9.64816 1.70696 7.72049 2.87911 6.5345C4.04483 5.35504 5.92991 5.35504 7.09562 6.5345Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5443 5.12861C24.4865 7.0937 24.4865 10.2749 22.5443 12.24L17.6707 17.1712C15.7221 19.1428 12.5578 19.1428 10.6092 17.1712L7.09499 13.6155L15.4829 5.12861C17.4315 3.157 20.5957 3.157 22.5443 5.12861ZM16.9054 6.5345L9.90748 13.6154L12.0317 15.7653C13.1974 16.9448 15.0825 16.9448 16.2482 15.7653L21.1219 10.8341C22.294 9.64816 22.294 7.72049 21.1219 6.5345C19.9561 5.35504 18.0711 5.35504 16.9054 6.5345Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1H18C19.1046 1 20 1.89543 20 3V11.5C20 15.9183 16.4183 19.5 12 19.5C7.58172 19.5 4 15.9183 4 11.5V3C4 1.89543 4.89543 1 6 1Z",
    fill: "#FDBB53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C13.933 13.5 15.5 11.933 15.5 10C15.5 8.067 13.933 6.5 12 6.5C10.067 6.5 8.5 8.067 8.5 10C8.5 11.933 10.067 13.5 12 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21H8C7.44772 21 7 21.4477 7 22C7 22.5523 7.44772 23 8 23H16C16.5523 23 17 22.5523 17 22C17 21.4477 16.5523 21 16 21Z",
    fill: "#F47B04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/cup_icon.3be74be0847a34a8a8ab03e7057d187a.svg";
export { ForwardRef as ReactComponent };